import React from 'react'

const FileTypeIcon = ({mimeType}) => {

  let iconCssClass = 'icon-';
  iconCssClass += (mimeType) ? mimeType.substr('application/'.length) : 'unknown';

  return (<span className={'icon ' + iconCssClass}/>)
};

export default FileTypeIcon;